class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerSection = document.querySelector('.section-header');
    this.closeTimer = null;
    this.onMouseEnterHandler = this.onMouseEnter.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeave.bind(this);
    this.onSummaryClickHandler = this.onSummaryClick.bind(this);

    this.addEventListener('mouseenter', this.onMouseEnterHandler);
    this.addEventListener('mouseleave', this.onMouseLeaveHandler);
    this.content?.addEventListener('mouseenter', this.onMouseEnterHandler);
    this.content?.addEventListener('mouseleave', this.onMouseLeaveHandler);

    this.mainDetailsToggle.querySelector('summary')?.addEventListener('click', this.onSummaryClickHandler);
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  isHoveringMenu() {
    return this.matches(':hover') || Boolean(this.content?.matches(':hover'));
  }

  openMenu() {
    clearTimeout(this.closeTimer);
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  onMouseEnter() {
    if (!this.isDesktop()) return;
    this.openMenu();
  }

  onMouseLeave(event) {
    if (!this.isDesktop()) return;

    const next = event.relatedTarget;
    if (next && (this.contains(next) || this.content?.contains(next))) return;

    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      if (this.isHoveringMenu()) return;
      this.close();
    }, 320);
  }

  onSummaryClick(event) {
    if (!this.isDesktop()) return;

    const anchor = event.target.closest('a.header__menu-item-link');
    if (!anchor || !this.mainDetailsToggle.querySelector('summary')?.contains(anchor)) return;

    const href = anchor.getAttribute('href');
    if (!href || href === '#') return;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(anchor.href);
  }

  close() {
    clearTimeout(this.closeTimer);
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );

    if (this.headerSection) {
      const anyOpen = document.querySelector('header-menu details[open]');
      this.headerSection.classList.toggle('menu-open', Boolean(anyOpen));
    }

    if (this.mainDetailsToggle.open) {
      document.querySelectorAll('header-menu details[open]').forEach((details) => {
        if (details !== this.mainDetailsToggle) {
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }
}

customElements.define('header-menu', HeaderMenu);
